module.exports = __webpack_public_path__ + "media/images/ahdr-df8f211952a9747fc7e14ff1005cb286.png";